<ion-header>
  <ion-toolbar mode="ios">
    <ion-title text-center>
      Select a reason for changing the order to {{ buttonClicked | lowercase }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon
          class="position-rule"
          slot="icon-only"
          name="close-circle"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid *ngIf="reasons?.length > 0">
    <ion-row *ngFor="let rsn of reasons" (click)="selectReason(rsn)">
      <ion-col size="12">
        <ion-item lines="none" class="card-background">
          <ion-text text-regular class="txt-color">
            {{ rsn?.title }}
          </ion-text>
          <ion-icon
            class="icon-color"
            name="radio-button-off"
            slot="end"
            [hidden]="selectedReasonId === rsn.id"
          ></ion-icon>
          <ion-icon
            name="checkmark-circle"
            slot="end"
            color="primary"
            [hidden]="selectedReasonId != rsn.id"
          ></ion-icon>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-item lines="none">
          <ion-textarea
            class="txt-area-brdr"
            text-regular
            [rows]="1"
            [(ngModel)]="cancelReason"
            [placeholder]="'write your reasons...'"
          ></ion-textarea>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button
          centered=""
          [disabled]="!selectedReasonId || !cancelReason"
          (click)="submit()"
          recykal-button=""
          size="large"
          expand="block"
          color="primary"
        >
          Done
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
